module.exports = __webpack_public_path__ + "img/card-role-title.a003b9d8.png";